<template>
    <div>
      <b-card-actions action-collapse title="Edit Voyage">
        <div>
          <div class="btn-delete-all text-right" @click="updateVoyage()">
            <b-button variant="gradient-primary" class="btn-icon btn-delete-all">
              <feather-icon icon="SaveIcon" />
            </b-button>
          </div>
          <div>
            <b-row>
              <b-col b-col cols="12" lg="6" md="6" sm="12">
                <b-form-group label="Vessel" label-for="vessel">
                  <v-select
                    id="vessel"
                    placeholder="Vessel"
                    label="title"
                    :options="vesselArray"
                    v-model="form.vessel"
                  >
                  </v-select>
                </b-form-group>
              </b-col>
              <b-col b-col cols="12" lg="6" md="6" sm="12">
              <b-form-group label="Num Voyage" label-for="num">
                <b-form-input
                  id="num"
                  placeholder="Num Voyage"
                  v-model="form.numero"
                />
              </b-form-group>
            </b-col>
              <b-col b-col cols="12" lg="6" md="6" sm="12">
                <b-form-group label="Start date" label-for="start">
                  <b-form-datepicker
                    placeholder="Voyage"
                    v-model="form.startDate"
                    required
                    id="start"
                  />
                </b-form-group>
              </b-col>
              <b-col b-col cols="12" lg="6" md="6" sm="12">
                <b-form-group label="End date" label-for="end">
                  <b-form-datepicker
                  placeholder="Voyage"
                  v-model="form.endDate"
                  required
                  id="end"
                  />
                </b-form-group>
              </b-col>
              <b-col b-col cols="12" lg="6" md="6" sm="12">
                <b-form-group label="Port of Loading" label-for="loading">
                  <v-select
                    id="loading"
                    v-model="form.loadingPort"
                    placeholder="Depart"
                    label="title"
                    :options="departArray"
                    @input="updateArrivalPorts(form.loadingPort)"
                  >
                  </v-select>
                </b-form-group>
              </b-col>
              <b-col b-col cols="12" lg="6" md="6" sm="12">
                <b-form-group label="Port of Discharging" label-for="discharging">
                  <v-select
                    id="discharging"
                    v-model="form.dischargePort"
                    placeholder="Arrival"
                    label="title"
                    :options="arrivalArray"
                    @input="updateDeparturePorts(form.dischargePort)"
                  >
                  </v-select>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-card-actions>
    </div>
  </template>

<script>
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import {
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BButton,
  BFormSelect,
  BFormDatepicker,
  BAvatar,
  BPagination,
  BImg,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";
import { heightTransition } from "@core/mixins/ui/transition";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import axios from "@axios";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
    components: {
        BDropdown,
        BDropdownItem,
        ToastificationContent,
        BForm,
        BRow,
        BCol,
        BButton,
        BFormGroup,
        BFormInput,
        BCardActions,
        BFormSelect,
        vSelect,
        BFormDatepicker,
        BAvatar,
        BPagination,
        BImg
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
data() {
    return {
        form : {
            numero : '',
            vessel : '',
            loadingPort : '',
            dischargePort : '',
            startDate : '',
            endDate : '',
            stopovers : [],
        },
        vesselArray: [],
        ports: [],
        departArray: [],
        arrivalArray: [],
    }
},
    async created() {
        window.addEventListener("resize", this.initTrHeight);
        await this.getData()
        await this.getVessels()
        await this.getPorts()
    },
    destroyed() {
        window.removeEventListener("resize", this.initTrHeight);
    },
    methods: {
        async getData() {
            const id = this.$router.history.current.query.id
            const response = await axios.get(`https://mtl-feeder-nodejs.onrender.com/api/voyages`, {
                params: { id },
            }); 
            this.form =  response.data.data
        },
        async getVessels() {
            this.vesselArray = [];
            const response = await axios.get("https://mtl-feeder-nodejs.onrender.com/api/vessels");
            response.data.data.forEach(element => {
                this.vesselArray.push(element.title)
            });
        },
        async getPorts() {
            const response = await axios.get("https://mtl-feeder-nodejs.onrender.com/api/ports")
            response.data.data.forEach((item,index) => {
                this.ports.push({
                    _id : item._id,
                    portAgent : item.portAgent._id,
                    title : item.title
                })  
            });   
            this.departArray = this.ports.filter(item => item.portAgent !== this.form.arrivalPortAgent)
            this.arrivalArray = this.ports
        },
        updateArrivalPorts(port) {
            this.form.loadingPort = port ? port.title : ''
            this.arrivalArray = port ? this.ports.filter(item => item._id !== port._id) : this.ports
        },
        updateDeparturePorts(port) {
            this.form.dischargePort = port ? port.title : ''
            this.departArray = port ? this.ports.filter(item => item._id !== port._id) : this.ports
        },
        async updateVoyage() {
            const id = this.$router.history.current.query.id
            if (Object.values(this.form).some(value => value === '' || value === null)) {
                this.$toast({
                component: ToastificationContent,
                props: {
                    title: "Fill out the form",
                    icon: "EditIcon",
                    variant: "warning",
                },
                });      
            }
            else {
                axios.put(`https://mtl-feeder-nodejs.onrender.com/api/voyages/${id}`, this.form)
                .then(async (response) => {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                    title: "voyage updated",
                    icon: "EditIcon",
                    variant: "success",
                    },
                });
                })
                .catch((error) => {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                    title: "Error during update",
                    icon: "EditIcon",
                    variant: "danger",
                    },
                });
                });
            }
        }
    }
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>